import * as hooks from '@owl-nest/hooks'

export function useInvalidateCache<T>(
  isInvalidKey: (key: string) => boolean,
  setCache: (setCache: (cache: hooks.Cache<T>) => hooks.Cache<T>) => void,
) {
  return () => {
    setCache((cache) => {
      return Object.fromEntries(
        Object.entries(cache).map(([key, value]) => {
          return isInvalidKey(key) ? [key, { ...value, stale: true }] : [key, value]
        }),
      )
    })
  }
}
